import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login__container" }
const _hoisted_3 = { class: "login__title" }
const _hoisted_4 = { class: "login__text text-capitalize-first" }
const _hoisted_5 = {
  key: 0,
  class: "login__form"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('labels.invitation_form_title')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('labels.invite_set_password')), 1),
      (_ctx.invite)
        ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control login__input user-icon",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invite!.user.email) = $event)),
              readonly: "",
              placeholder: _ctx.$t('labels.login')
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.invite!.user.email]
            ]),
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`password`),
              class: "w-100"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control login__input password-icon"]),
                  type: "password",
                  id: "password",
                  name: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.password) = $event)),
                  placeholder: _ctx.$t('labels.password')
                }, null, 10, _hoisted_7), [
                  [_vModelText, _ctx.request.password]
                ])
              ]),
              _: 1
            }, 8, ["errors"]),
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`passwordConfirm`),
              class: "w-100"
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control login__input password-icon"]),
                  type: "password",
                  id: "password_confirm",
                  name: "password_confirm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.passwordConfirm) = $event)),
                  placeholder: _ctx.$t('labels.confirm_password')
                }, null, 10, _hoisted_8), [
                  [_vModelText, _ctx.request.passwordConfirm]
                ])
              ]),
              _: 1
            }, 8, ["errors"]),
            _createVNode(_component_LoaderButton, {
              type: "button",
              class: "btn btn--accept text-capitalize-first",
              "on-click": _ctx.save
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('button.create_account')), 1)
              ]),
              _: 1
            }, 8, ["on-click"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}